import Modal from "@/components/Modal";
import Form from "../../components/Form";

import "./style.css";

export default class ResetPasswordModal extends Modal {
  static selector = ".reset-password-modal";

  constructor(block) {
    super(block);

    this.block = block;

    this.successMessage = this.block.querySelector(".form__success");

    this.formElement = this.block.querySelector(".reset-password-modal__form");
    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: false,
    });
  }

  handleSubmitFailed = () => {};

  handleSubmitSucceeded = () => {
    this.successMessage.innerText =
      window.saee.copy["Your password has been reset"];
    window.history.replaceState({}, document.title, "/");
    this.modalTimeout = setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  clearFormErrorState = () => {
    this.block.querySelectorAll(".form__error").forEach((error) => {
      error.innerText = "";
    });
    this.block
      .querySelectorAll(".form__group-error")
      .forEach((error) => (error.innerText = ""));
    this.block.querySelectorAll(".form__group").forEach((group) => {
      if (group.classList.contains("form__group--wrong")) {
        group.classList.remove("form__group--wrong");
      }
    });
  };

  // Lifecycle methods
  onReady() {
    this.open();
  }

  modalDidMount = async () => {};
  modalWillOpen = async () => {};

  modalDidUpdate = async () => {};
  modalDidClose = async () => {
    this.clearFormErrorState();
  };

  onDestroy() {
    clearTimeout(this.modalTimeout);
  }
}
